/* tslint:disable */
import {
  Vendor,
  StockMovement
} from '../index';

declare var Object: any;
export interface StoreInterface {
  "name": string;
  "code": string;
  "externalId"?: string;
  "status"?: number;
  "vendorId"?: any;
  "address"?: string;
  "updatedAt"?: Date;
  "updatedBy"?: any;
  "parent"?: number;
  "storeType"?: string;
  "isSalesStore"?: boolean;
  "id"?: number;
  vendor?: Vendor;
  stockMovement?: StockMovement[];
}

export class Store implements StoreInterface {
  "name": string;
  "code": string;
  "externalId": string;
  "status": number;
  "vendorId": any;
  "address": string;
  "updatedAt": Date;
  "updatedBy": any;
  "parent": number;
  "storeType": string;
  "isSalesStore": boolean;
  "id": number;
  vendor: Vendor;
  stockMovement: StockMovement[];
  constructor(data?: StoreInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Store`.
   */
  public static getModelName() {
    return "Store";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Store for dynamic purposes.
  **/
  public static factory(data: StoreInterface): Store{
    return new Store(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Store',
      plural: 'stores',
      path: 'stores',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "externalId": {
          name: 'externalId',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "vendorId": {
          name: 'vendorId',
          type: 'any'
        },
        "address": {
          name: 'address',
          type: 'string'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'any'
        },
        "parent": {
          name: 'parent',
          type: 'number',
          default: 0
        },
        "storeType": {
          name: 'storeType',
          type: 'string',
          default: 'branch'
        },
        "isSalesStore": {
          name: 'isSalesStore',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        vendor: {
          name: 'vendor',
          type: 'Vendor',
          model: 'Vendor',
          relationType: 'belongsTo',
                  keyFrom: 'vendorId',
          keyTo: 'id'
        },
        stockMovement: {
          name: 'stockMovement',
          type: 'StockMovement[]',
          model: 'StockMovement',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'id'
        },
      }
    }
  }
}
